import { useOverviewStatus } from "@/hooks/use-overview";
import { useStatistics } from "@/hooks/use-statistics";
import { setStatus } from "@/tokens/status";
import { useEffect } from "react";
import { DualGlobeHero } from "./dual-globe-hero";
import { GrowthChart } from "./growth-chart";

export function OverviewPage() {
  const { data: statusData } = useOverviewStatus();
  const { data: stats } = useStatistics();

  const status = statusData?.status ?? "healthy";

  useEffect(() => {
    setStatus(status);
  }, [status]);

  return (
    <div className="iris-page">
      {/* Page title */}
      <h1 className="iris-page__title">
        Dashboard
        <br />
        Overview
      </h1>
      <p className="iris-page__subtitle">Real-time ingestion health &amp; pipeline monitoring</p>

      {/* Dual Globe Hero — dev left, prod right + health widgets + KPI tiles */}
      <section
        style={{
          opacity: 0,
          animation: "fadeUp 0.9s cubic-bezier(.2,.8,.2,1) 0.2s forwards",
        }}
      >
        <DualGlobeHero />
      </section>

      {/* Growth chart */}
      <section
        style={{
          opacity: 0,
          animation: "fadeUp 0.7s cubic-bezier(.2,.8,.2,1) 0.45s forwards",
        }}
      >
        <GrowthChart
          entities={stats?.activity?.new_entities_daily ?? []}
          groups={stats?.activity?.new_groups_daily ?? []}
          messages={stats?.activity?.new_messages_daily ?? []}
        />
      </section>
    </div>
  );
}
